import React, { Component } from 'react'
import _ from 'lodash'
import moment from 'moment'
import {
  FilterTable
} from 'camino-react'

import TimesheetModal from 'Components/Timesheets/TimesheetModal'

export default class MyTimesheetsContainer extends Component {
  constructor (props) {
    super(props)
    this.contentSections = ["Today's Timesheets", 'All My Timesheets']
    const { data } = props

    this.state = {
      currentContentSectionTab: "Today's Timesheets",
      todayView: true,
      timesheetsToday: [],
      timesheetsAll: data
    }
  }

  componentDidMount () {
    const { data } = this.props
    const startOfToday = moment().startOf('day').format()
    const endOfToday = moment().endOf('day').format()

    const timesheetsToday = _.filter(data, (timesheet) => {
      const timesheetStartTime = moment(timesheet.start_time).format()
      return (
        (timesheetStartTime > startOfToday) && (timesheetStartTime < endOfToday)
      )
    })

    this.setState({
      timesheetsToday
    })
  }

  currentContentSectionTabClass = (tabName) => {
    const { currentContentSectionTab } = this.state

    if (currentContentSectionTab === tabName) {
      return 'content-section__header-tab--active'
    }

    return ''
  }

  formatStringFromObject (object) {
    return JSON.stringify(object).replace(/\\n/g, ' ').slice(1, -1)
  }

  setTimesheet = (type, timesheet) => {
    this.setState({ [`${type}Timesheet`]: timesheet })
  }

  showContentSection = (event, correspondenceForm) => {
    event.preventDefault()
    const todayView = correspondenceForm === "Today's Timesheets"

    this.setState({
      currentContentSectionTab: correspondenceForm,
      todayView
    })
  }

  render () {
    const {
      todayView,
      timesheetsAll,
      timesheetsToday,
      viewableTimesheet
    } = this.state
    const {
      contentSections,
      currentContentSectionTabClass,
      formatStringFromObject,
      setTimesheet,
      showContentSection
    } = this

    const contentSectionHeaderTabs = _.map(contentSections, sectionName => (
      <div
        key={sectionName}
        className={`content-section__header-tab ${currentContentSectionTabClass(sectionName)}`}
        onClick={event => (showContentSection(event, sectionName))}
      >
        {sectionName}
      </div>
    ))

    const columns = [
      {
        text: 'For',
        accessor: 'timetrackable_column'
      },
      {
        text: 'Description',
        accessort: 'description',
        Cell: row => (
          <span
            style={{ cursor: 'pointer', color: '#00baea' }}
            onClick={() => { setTimesheet('viewable', row.original) }}
          >
            {formatStringFromObject(row.original.description)}
          </span>
        )
      },
      {
        text: 'Start',
        accessor: 'start_time',
        type: 'datetime'
      },
      {
        text: 'End',
        accessor: 'end_time',
        type: 'datetime'
      },
      {
        text: 'Duration',
        accessor: 'timesheet_duration_pretty',
        type: 'string'
      },
      {
        text: 'Chargeable',
        type: 'boolean'
      },
      {
        text: 'Actions',
        type: 'action_icons'
      }
    ]

    const totalDuration = () => {
      const timesheetDurations = _.map(timesheetsToday, timesheet => timesheet.timesheet_duration)

      return timePretty(_.sum(timesheetDurations))
    }

    const timePretty = (num) => {
      const hours = Math.floor(num) % 24
      const hoursPretty = `${hours} ${(hours >= 2) ? 'hours' : 'hour'}`
      const minutes = Math.floor((num % 1) * 60)
      const minutesPretty = `${minutes} ${(minutes >= 2) ? 'minutes' : 'minute'}`

      if (num % 1 === 0) {
        return `${hoursPretty}`
      }

      if (num > 1) {
        return `${hoursPretty} and ${minutesPretty}`
      }

      return `${minutesPretty}`
    }

    return (
      <section className="content-section">
        {(todayView) && (
          <div className="content-section-block__title-actions">
            <h3>
              {totalDuration() !== '0 hour' && ('Total Time Today: ')}
              <span style={{ fontWeight: '600' }}>
                {(totalDuration() === '0 hour') ? " Log today's first timesheet..." : ` ${totalDuration()}`}
              </span>
            </h3>
          </div>
        )}
        <div className="content-section__header-tabs-container content-section__title--no-margin">
          {contentSectionHeaderTabs}
        </div>
        { todayView && (
          <FilterTable
            data={timesheetsToday}
            columns={columns}
            pageSizeOptions={[10, 25, 50, 100]}
            defaultPageSize={100}
          />
        )}

        { !todayView && (
          <FilterTable
            columns={columns}
            data={timesheetsAll}
            pageSizeOptions={[10, 25, 50, 100]}
            defaultPageSize={100}
          />
        )}

        { viewableTimesheet && (
          <TimesheetModal
            open
            viewableTimesheet={!!viewableTimesheet}
            title="Timesheet Summary"
            url={null}
            method={null}
            timesheet={viewableTimesheet}
            onClose={() => {
              this.setTimesheet('viewable', null)
            }}
            modalOpen
          />
        )}
      </section>
    )
  }
}
